import React, { createContext, useContext, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const ChatSidebarContext = createContext<{
  isVisible: boolean;
  show: () => void;
  hide: () => void;
  toggle: () => void;
}>({
  isVisible: false,
  show: noop,
  hide: noop,
  toggle: noop,
});

const ChatSidebarProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const show = () => {
    setIsVisible(true);
  };

  const hide = () => {
    setIsVisible(false);
  };

  const toggle = () => {
    setIsVisible(!isVisible);
  };

  return (
    <ChatSidebarContext.Provider
      value={{
        isVisible,
        show,
        hide,
        toggle,
      }}
    >
      {children}
    </ChatSidebarContext.Provider>
  );
};

export default ChatSidebarProvider;
export const useChatSidebar = () => useContext(ChatSidebarContext);
